var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "25", height: "24", viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { clipPath: "url(#id-11a)" },
      React.createElement("path", { d: "M8.53613 4L16.0361 11.5L8.53613 19", stroke: "#222429", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })
    ),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "clipPath",
        { id: "id-11a" },
        React.createElement("path", { fill: "#fff", transform: "translate(.536)", d: "M0 0H24V24H0z" })
      )
    )
  );
});